<template>
  <v-dialog :value="show" width="600" persistent>
    <v-card>
      <v-card-title>
        {{ $t('settings.user.otp.title') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-2 pb-0">
        <v-switch v-model="enabled" :disabled="!canWrite"
          :label="$t('settings.user.otp.enable')">
          <template v-slot:prepend>
            <v-icon :color="enabled ? 'green' : 'red'">
              mdi-lock{{ enabled ? '' : '-open-variant'}}
            </v-icon>
          </template>
        </v-switch>
      </v-card-text>

      <v-card-text class="pb-0">
        <v-row align="center">
          <v-col md="4">
            <v-radio-group v-model="method" :disabled="!canWrite">
              <v-radio :label="$t('settings.user.otp.sms')" value="sms" v-if="smsAvailable"/>
              <v-radio :label="$t('settings.user.otp.email')" value="email"/>
              <v-radio :label="$t('settings.user.otp.qrcode')" value="authenticator_app"/>
            </v-radio-group>
          </v-col>
          <v-col>
            <v-text-field v-show="method==='sms'" :error-messages="errSMS"
              :label="$t('settings.user.otp.phoneNum')"
              :disabled="!canWrite" v-model="phoneNum"/>
            <v-text-field v-show="method==='email'" :error-messages="errEmail"
              :label="$t('settings.user.otp.emailAddr')"
              :disabled="!canWrite" v-model="email"/>
            <QRCode :uri="provURI" v-if="method==='authenticator_app'" class="ma-2"/>
          </v-col>
        </v-row>
        <v-alert v-if="!canWrite" type="warning">
          {{ $t('settings.user.otp.errPermissions') }}
        </v-alert>
      </v-card-text>

      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="$emit('close')" text>
          {{ $t('settings.user.btn.cancel') }}
        </v-btn>
        <v-btn color="primary" @click="update" :disabled="!canWrite" text>
          {{ $t('settings.user.btn.update') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import QRCode from './qrcode'
import API from '@/api'
import events from 'Store/events'

export default {
  name: 'settings-user-otp',
  data () {
    return {
      errSMS: '',
      errEmail: ''
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  components: { QRCode },
  watch: {
    enabled: function (on) {
      if (on && !this.method) {
        this.method = this.smsAvailable ? 'sms' : 'email'
      }
    }
  },
  computed: {
    ...mapGetters({
      canWrite: 'permissions/otpWrite',
      getEnabled: 'settings/otpEnabled',
      getMethod: 'settings/otpMethod',
      getSmsAvailable: 'settings/otpSmsAvailable',
      getEmail: 'settings/otpEmail',
      getPhoneNum: 'settings/otpPhoneNum',
      getProvUri: 'settings/otpProvUri'
    }),
    enabled: {
      get: function () { return this.getEnabled },
      set: function (val) { this.setEnabled(val) }
    },
    method: {
      get: function () { return this.getMethod },
      set: function (val) { this.setMethod(val) }
    },
    smsAvailable: {
      get: function () { return this.getSmsAvailable }
    },
    email: {
      get: function () { return this.getEmail },
      set: function (val) {
        if (val.length > 0) {
          this.errEmail = ''
        }
        this.setEmail(val)
      }
    },
    phoneNum: {
      get: function () { return this.getPhoneNum },
      set: function (val) {
        if (val.length > 0) {
          this.errSMS = ''
        }
        this.setPhoneNum(val)
      }
    },
    provURI: {
      get: function () { return this.getProvUri },
      set: function (val) { this.setProvURI(val) }
    }
  },
  methods: {
    ...mapActions({
      setEnabled: 'settings/setOTPEnabled',
      setMethod: 'settings/setOTPMethod',
      setEmail: 'settings/setOTPEmail',
      setPhoneNum: 'settings/setOTPPhoneNum',
      setProvURI: 'settings/setOTPProvURI'
    }),
    validate: function () {
      const num = this.phoneNum.trim()
      this.errSMS = ''
      const email = this.email.trim()
      this.errEmail = ''

      if (this.method === 'sms' &&
          !/^\+?[\d -]+$/.test(num)) {
        this.errSMS = this.$t('settings.user.otp.errSMS')
        return false
      }

      if (this.method === 'email' &&
          !/^[^@]+@[^@]+$/.test(email)) {
        this.errEmail = this.$t('settings.user.otp.errEmail')
        return false
      }

      return true
    },
    updateValues: function () {
      if (!this.enabled) {
        return { otp_enabled: false }
      }

      return {
        otp_enabled: true,
        otp_method: this.method,
        ...(this.method === 'sms'
          ? { otp_phone_number: this.phoneNum.replaceAll(/[^+\d]/g, '') }
          : {}),
        ...(this.method === 'email' ? { otp_email: this.email } : {})
      }
    },
    update: function () {
      if (!this.validate()) {
        return false
      }
      events.mask(this.$t('settings.user.otp.updating'))
      API.updateOTP(this.updateValues()).then(() => {
        events.pubNotify({
          text: 'settings.user.otp.updateOk',
          status: 'success'
        })
        this.$emit('close')
      }).catch(err => {
        this.dbg('Failed to update OTP')
        this.dbg(err)
        events.pubError(this.$t('settings.user.otp.errUpdate') +
          API.getException(err))
      }).finally(() => {
        events.unmask()
      })
    }
  }
}
</script>

<style scoped>
</style>
